<template>
  <overlay-scrollbars id="katalog-scroll-container" :options="{ className: 'content white custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <TheLoader :active="loading || updating" :update="updating"/>

    <section class="content large white">
      <table class="large fixed visible sticky-table-header compressed" style="width: 100%">
      <thead>
        <tr>
          <th>Kundenr</th>
          <th>Navn</th>
          <th>Email</th>
          <th>Adresse</th>
          <th>Hvorfor katalog</th>
          <th>Endret av</th>
          <th>Endret dato</th>
          <th class="align-right">&nbsp;</th>
        </tr>
      </thead>
      <tbody v-if="!loading && items.length < 1">
        <tr>
          <td colspan="7">
            <em>Fant ingen kunder...</em>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="item in items" v-bind:key="item.id">
          <td>{{ item.Kundenr }}</td>
          <td>{{ item.full_name }}</td>
          <td>{{ item.Email || '-' }}</td>
          <td v-if="itemLeveringsAdresse(item)">{{ itemLeveringsAdresse(item).full_address }}</td>
          <td v-else style="color: red;">Mangler adresse</td>
          <td>{{ item.KatalogInfo || '-' }}</td>
          <td>{{ item.KatalogInfo_endret_av || '-'}}</td>
          <td>{{ item.KatalogInfo_endret_tid | avantidatetime }}</td>
          <td class="align-right">
            <a href="javascript:;" @click="openAddressModal(item)">
              Rediger adresse
            </a>
          </td>
        </tr>
      </tbody>
      </table>
      <br>
      <br>
      <div class="pagination-container"  v-if="pages > 1" style="margin-top: -1rem;">
        <paginate v-model="params.page"
          :page-count="pages"
          :page-range="11"
          :click-handler="setPage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </overlay-scrollbars>
</template>

<script>
import KundeService from '@/services/KundeService'
import fileDownload from 'js-file-download'
import moment from 'moment'
import Papa from 'papaparse'
import bus from '@/plugins/event-bus'

export default {
  name: 'KatalogKundeList',
  data () {
    return {
      loading: false,
      updating: false,
      items: [],
      pages: 1,
      params: null,
      selected: []
    }
  },
  created () {
    bus.$off('reload-kataloglist')
    bus.$off('export-kataloglist')
    bus.$off('kunde-address-updated')
  },
  mounted () {
    bus.$on('reload-kataloglist', () => this.resetAndReload())
    bus.$on('export-kataloglist', () => this.exportToExcel())
    bus.$on('kunde-address-updated', (data) => this.onKundeAddressUpdated(data))
  },
  activated () {
    this.loading = true

    this.setDefaultParams()
    this.fetch()
  },
  methods: {
    itemLeveringsAdresse: function (item) {
      if (!item.kundeadresse) {
        return null
      }

      return this._.find(item.kundeadresse, ['Type', 'levering']) || null
    },
    setDefaultParams: function () {
      this.params = {
        page: 1,
        sort: 'Kundenr',
        direction: 'desc',
        limit: 100
      }
    },
    openAddressModal: function (item) {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: item,
          event: 'kunde-address-updated'
        }
      )
    },
    onKundeAddressUpdated: function (data) {
      const index = this.items.findIndex(x => x.Kundenr === data.Kundenr)

      if (index !== -1) {
        this.$set(this.items, index, data)
      }
    },
    resetAndReload: function () {
      this.updating = true
      this.$emit('onSubmitStatusChange', 'loading')
      this.setDefaultParams()
      this.fetch()
    },
    setPage: function (page) {
      let vm = this

      window.jQuery('.os-viewport', window.jQuery('#katalog-scroll-container')).animate({
        scrollTop: 0
      }, 200, function () {
        vm.updating = true
        vm.$emit('onSubmitStatusChange', 'loading')
        vm.fetch()
      })
    },
    exportToExcel: async function () {
      this.$emit('onSubmitStatusChange', 'exporting')
      const params = this._.cloneDeep(this.params)
      params.export = 1
      let items = []

      for (let i = 1; i <= this.pages; i++) {
        params.page = i

        await KundeService.kataloglist(params)
          .then((response) => {
            items = [...items, ...response.data]
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
          })
          .then(() => {
            console.log('Now make submittable again')
          })
      }
      this.$emit('onSubmitStatusChange', 'submittable')

      this.makeExcel(items)
    },
    makeExcel: function (data) {
      const xarray = []
      const fields = [
        'Kundenr',
        'Navn',
        'Firmanavn',
        'Email',
        'Adresse',
        'Adresse2',
        'Co',
        'Postnr',
        'Poststed',
        'Land',
        'KatalogInfo',
        'Endret_av',
        'Endret_tid'
      ]

      // Note: wrap value in ="VALUE" to keep leading zeroes.
      xarray.push(fields)
      data.forEach(element => {
        const addr = this.itemLeveringsAdresse(element)
        const temp = [
          '="' + (element.Kundenr) + '"',
          '="' + (element.full_name || '-') + '"',
          '="' + (element.FirmaNavn || '-') + '"',
          '="' + (element.Email || '-') + '"',
          '="' + (addr ? (addr.Adresse || '-') : '-') + '"',
          '="' + (addr ? (addr.Adresse2 || '-') : '') + '"',
          '="' + (addr ? (addr.Co || '-') : '') + '"',
          '="' + (addr ? (addr.Postnr || '') : '') + '"',
          '="' + (addr ? (addr.Poststed || '-') : '') + '"',
          '="' + (addr ? (addr.Landkode || '-') : '') + '"',
          '="' + (element.KatalogInfo || '-') + '"',
          '="' + (element.KatalogInfo_endret_av || '-') + '"',
          '="' + (element.KatalogInfo_endret_tid || '-') + '"'
        ]

        xarray.push(temp)
      })

      // Finally make csv and force download...
      const csv = '\ufeff' + Papa.unparse(xarray, { delimiter: ';' })
      const blob = new Blob([csv], {
        type: 'application/csvcharset=utf-8'
      })

      fileDownload(blob, 'katalog-' + moment().format('DDMMYYHms') + '.csv')
    },
    fetch: function () {
      this.selected = []

      KundeService.kataloglist(this.params)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1

          this.items = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/KatalogKundeList.vue